import type {
  CapturedAnalyticsEvent,
  OnboardingEventContract,
} from "./onboardingEventContracts";

const matchesRequirement = (
  candidate: CapturedAnalyticsEvent,
  expectedMatch?: Record<string, unknown>
): boolean => {
  if (!expectedMatch) return true;
  const properties = candidate.properties ?? {};

  return Object.entries(expectedMatch).every(
    ([key, value]) => properties[key] === value
  );
};

export function validateOnboardingEvents(
  events: CapturedAnalyticsEvent[],
  contract: OnboardingEventContract
): string[] {
  const errors: string[] = [];

  for (const requirement of contract.required) {
    const found = events.some(
      (candidate) =>
        candidate.event === requirement.event &&
        matchesRequirement(candidate, requirement.match)
    );

    if (!found) {
      errors.push(`Missing required event '${requirement.event}' for contract '${contract.id}'.`);
    }
  }

  for (const forbiddenEvent of contract.forbidden ?? []) {
    const found = events.some((candidate) => candidate.event === forbiddenEvent);
    if (found) {
      errors.push(`Forbidden event '${forbiddenEvent}' was captured for contract '${contract.id}'.`);
    }
  }

  if (contract.ordered?.length) {
    let cursor = -1;
    for (const orderedEvent of contract.ordered) {
      const nextIndex = events.findIndex(
        (candidate, index) => index > cursor && candidate.event === orderedEvent
      );
      if (nextIndex === -1) {
        errors.push(`Ordered event '${orderedEvent}' was not found after index ${cursor} for contract '${contract.id}'.`);
        break;
      }
      cursor = nextIndex;
    }
  }

  return errors;
}

